import './SharedQueriesStyle.css';
import MigrateQueries, { MigrateQueryType } from './MigrateQueries';
import * as React from 'react';
import { FC, useState, useEffect } from 'react';
import { UATConstants, HttpVerbs } from '../Common/Models/UATConstants';
import { sortBy } from 'lodash-es';
import { ServiceFactoryClientExecuteApi } from '../Common/Services/ServiceFactoryToExecuteApi';
import ErrorResponse from '../Models/ErrorResponse';
import {
  DetailsList,
  DetailsListLayoutMode,
  SelectionMode,
  IColumn,
  Selection,
  CheckboxVisibility,
} from '@fluentui/react/lib/DetailsList';
import { QueryActions } from './QueryActions';
import { connect } from 'react-redux';
import { getUserProfile, getUsers, setTeamFilter, setViews } from '../actions/Actions';
import {
  TextField,
  PrimaryButton,
  Spinner,
  SpinnerSize,
  IconButton,
  FontIcon,
  MessageBar,
  MessageBarButton,
  MessageBarType,
} from '@fluentui/react';
import { PickerComponent } from '../dashboard/PickerComponent';
import moment from 'moment';
import { ErrorMessage } from 'src/App/Components/Common/ErrorMessage';
import { SuccessMessage } from 'src/App/Components/Common/SuccessMessage';
import { store, StoreState } from 'src/Store';

export interface ISharedQueriesState {
  itemsSharedQueries: ISharedQuery[];
  itemsMyQueries: ISharedQuery[];
  itemsAll: ISharedQuery[];
  showSpinner: boolean;
}

export interface ISharedQueriesProps {
  flights: string[];
}

export interface ISharedQuery {
  key: string;
  name: string;
  path: string;
  createdDate: string;
  id: string;
  isSharedQuery: boolean;
  isMyQuery: boolean;
}
const SharedQueries: FC<ISharedQueriesProps> = ({ ...sharedQueriesProps }) => {
  const params = new URL(window.location.href).searchParams;
  const [showSpinner, setshowSpinner] = useState<boolean>(false);
  const [itemsSharedQueries, setItemsSharedQueries] = useState<ISharedQuery[]>([]);
  const [ItemsMyQueries, setItemsMyQueries] = useState<ISharedQuery[]>([]);
  const [ItemsAll, setItemsAll] = useState<ISharedQuery[]>([]);

  useEffect(() => {
    const params = new URL(window.location.href);
    const paths = params.pathname.split('/');
    if (paths.length > 2) {
      const token = paths[paths.length - 1];
      const newurl = params.origin + '/' + paths[1];
      //replace current url with new url
      window.history.pushState('', '', newurl);
      sessionStorage.setItem(UATConstants.jwtTokenForADOApi, token);
      getADOSharedQueries();
    } else {
      generateVSTSToken();
    }
  }, []);

  const generateVSTSToken = () => {
    setshowSpinner(true);
    ServiceFactoryClientExecuteApi.ExecuteRequest<any>(
      UATConstants.ApiPaths.GenerateVSTSToken,
      [],
      HttpVerbs.get,
      [],
      (response: any) => {
        setshowSpinner(false);
        //const res = encodeURI(response);
        window.location.href = response;
      },
      (response: ErrorResponse) => {
        console.error(response);
      }
    );
  };

  const getADOSharedQueries = () => {
    const storeState = store.getState() as StoreState;
    const userFlights = storeState.userProfile.flights;
    setshowSpinner(true);
    const ItemsAllQueries: ISharedQuery[] = [];
    ServiceFactoryClientExecuteApi.ExecuteAdoRequest<any>(
      UATConstants.ApiPaths.GetADOSharedQueries,
      [],
      HttpVerbs.post,
      userFlights,
      (queries: ISharedQuery[]) => {
        queries.forEach((item) => {
          //need to improve this logic for comparison
          if (item.path.includes('Shared Queries')) {
            item.isSharedQuery = true;
          } else if (item.path.includes('My Queries')) {
            item.isMyQuery = true;
          }
          ItemsAllQueries.push(item);
        });
        //Get All SharedQueries and MyQueries
        const ItemsAllSharedQrs = sortBy(
          ItemsAllQueries.filter((x) => x.isSharedQuery),
          (s) => s.name
        );
        const ItemsAllMyQrs = sortBy(
          ItemsAllQueries.filter((x) => x.isMyQuery),
          (s) => s.name
        );
        setItemsMyQueries(ItemsAllMyQrs);
        setItemsSharedQueries(ItemsAllSharedQrs);
        setItemsAll(ItemsAllQueries);
        setshowSpinner(false);
      },
      (response: ErrorResponse) => {
        console.error(response);
      },
      false,
      undefined,
      600000
    );
  };
  const flights = sharedQueriesProps.flights || [];
  const hasSharedQueriesFlight: boolean = flights.includes(UATConstants.SharedQueriesFlightName);
  return (
    <>
      <div className='contentBar'>
        {showSpinner && (
          <Spinner
            size={SpinnerSize.large}
            label={UATConstants.PlaceholdersAndTitles.Loading}
            ariaLive='assertive'
            className='loading-panel-full'
          />
        )}
      </div>
      {ItemsMyQueries.length > 0 && (
        <MigrateQueries
          itemsAll={ItemsMyQueries}
          migrateQueryType={MigrateQueryType.MyQuery}
          hasSharedQueries={hasSharedQueriesFlight}
        />
      )}
      {hasSharedQueriesFlight && itemsSharedQueries.length > 0 && (
        <MigrateQueries
          itemsAll={itemsSharedQueries}
          migrateQueryType={MigrateQueryType.SharedQuery}
          hasSharedQueries={hasSharedQueriesFlight}
        />
      )}
    </>
  );
};

const mapStateToProps = (state: any, ownProps: any) => ({
  ...state,
});

const mapDispatchToProps = {
  setUsers: getUsers,
  setTeam: setTeamFilter,
  setViews: setViews,
};
export default connect(mapStateToProps, mapDispatchToProps)(SharedQueries);
